"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const lodash_1 = require("lodash");
exports.ListMultiSelectComponent = (props) => {
    let selectField = "Loading...";
    try {
        if (lodash_1.isEmpty(props.model) || !Array.isArray(props.model)) {
            selectField = "";
        }
        const finalString = lodash_1.map(props.model, (selectValue) => {
            const foreignDoc = lodash_1.find(props.additionalModels[props.field.modelName], (doc) => {
                return doc[props.field.key] === selectValue;
            });
            let foreignTitle;
            if (lodash_1.isEmpty(foreignDoc)) {
                foreignTitle = selectValue + " Bad Value";
            }
            else {
                foreignTitle = foreignDoc[props.field.title];
            }
            return foreignTitle;
        }).join(", ");
        selectField = finalString;
    }
    catch (err) {
        selectField = "Loading...";
    }
    return React.createElement("div", null, selectField);
};
//# sourceMappingURL=ListMultiSelectComponent.js.map